/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { Modal, Box, Grid, Tooltip, Select, MenuItem, Button } from '@mui/material';
import { Country } from 'country-state-city';
import { Rnd } from 'react-rnd';
import { closeIconBlack } from '../../../shared/assets/images';
import { defaultUnitValues } from '../../../shared/constantVariable';
import { saveWinflowsFileContent } from '../../../shared/api/url-helper';
import { encrypt_data } from '../../../shared/utils';
import { getEmailUserType } from '../../../shared/helper';

function CountrySelection(props) {
  const { visibleCountrySelection, handleCloseCountrySelection, changeRegion, translateObject } = props;

  const [selectedCountry, setSelectedCountry] = useState([]);
  const [countryval, setCountryval] = useState('');
  // Function to save location data
  const Location_Save = (Location) => {
    // Get default unit set from localStorage or set it to an empty string
    const response_final = JSON.parse(localStorage.getItem('default_unit_set_dict')) || {
      'Volume Flow': defaultUnitValues.flow,
      'Pressure': defaultUnitValues.pressure,
      'Temperature': defaultUnitValues.temp,
      'Liquid Volume': defaultUnitValues.volume,
      'Flux': defaultUnitValues.flux,
      'Power': defaultUnitValues.power,
      'type': defaultUnitValues.type
    };
    const userMailId = sessionStorage.getItem('user_email');
    const getUserType = userMailId.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
    const payload_units = { 'country': Location, ...response_final };
    const encrypt_units = encrypt_data(payload_units);

    saveWinflowsFileContent(`units/${userMailId}`, userMailId, getEmailUserType(userMailId), encrypt_units)
      .then(() => { })
      .catch(() => { });
  };
  const handleChange = (e, str) => {
    const { value } = e.target;

    if (str === 'country') {
      setCountryval(value);
    }
  };
  useEffect(() => {
    const data = Country.getAllCountries().map((ele) => {
      return { value: ele.isoCode, label: ele.name };
    });
    setSelectedCountry(data);
  }, []);
  const handleCloseSplitModal = () => { handleCloseCountrySelection(); };
  const handleUpdate = () => {
    handleCloseCountrySelection();
    sessionStorage.setItem('country', countryval);
    sessionStorage.setItem('geolocationPromptShown', 'false');
    Location_Save(countryval);
    changeRegion();
  };
  return (
    <Modal
      hideBackdrop
      open={visibleCountrySelection}
      onClose={handleCloseCountrySelection}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="argoComp-modal"
    >
      <Box className=''>
        <Rnd
          default={{
            width: '25%',
            x: ((window.innerWidth / 2) - ((25 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((50 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick={false}
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='20%'
          cancel=".ro-table-grid"
          onDragStart={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          className='argoComp-box'>
          <Grid container className='argoComp-grid-container'>
            <Grid item xs={12}>
              <Grid item xs={12} className='model_header'>
                <div className='model_header_text S_heading'>{translateObject('Country Selection')}</div>
                <div className='argoComp-close-icon'>
                  <Tooltip title="Close">
                    <img
                      src={closeIconBlack}
                      alt="close"
                      onClick={handleCloseCountrySelection}
                      style={{ width: '14px', padding: '11px' }}
                      className="pointer"
                    />
                  </Tooltip>
                </div>
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ 'padding': '0.5rem' }}>
              <div className="normal-font no_drag S_Bold">{translateObject('Select Country')}</div>
              <div className='select-dropdown-argo mt-2 no_drag'>
                <Select
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  value={countryval}
                  name='waterSource'
                  fullWidth
                  onChange={(e) => { handleChange(e, 'country'); }}
                  data-testid='waterSource'>
                  {(selectedCountry || []).map((ele) => (
                    <MenuItem key={ele.label}
                      value={ele.label}>{ele.label}</MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
            <Grid className='splitter-mixer-update-button' item xs={12}>
              <div className='note-item'>
                <Grid container className='Argo-note-text sansW4SeLig M_Regular'>
                  <Grid item xs={12} className='no_drag S_Bold Note'>{translateObject('Note')}</Grid>
                  <Grid item xs={12} className='no_drag S_Regular primary_text'>{translateObject('Please select your country from the list given.')}</Grid>
                  <Grid item xs={12} className='no_drag S_Regular primary_text'>{translateObject('This selection allows Winflows to provide you with region-specific MemChem options.')}</Grid>
                  <Grid item xs={12} className='no_drag S_Regular primary_text'>{translateObject('Important: Your country selection is permanent and cannot be changed after submission.')}</Grid>
                </Grid>
              </div>
              <Grid container spacing={2}>
                <Grid item xs={6} md={12} sm={12}>
                  <div className="Argo-button">
                    <div className='cancel-ok-button'>
                      <Button variant="contained" className="sansW4SeLig M_Bold Secondary-Default_button"
                        size="small" style={{ width: '120px', marginRight: '15px' }} onClick={handleCloseSplitModal}> {translateObject('Cancel')} </Button>
                      <Button variant="contained" className="sansW4SeLig M_Bold Primary_Default_Button"
                        size="small" style={{ width: '120px' }} onClick={handleUpdate}> {translateObject('OK')} </Button>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
}

export default CountrySelection;